module.exports = __webpack_public_path__ + "img/aff01-preview.467b70c8.jpg";